<div class="titulo-component" [class.modal]="modal"> 
    <div>
        <i [ngClass]="icon"></i>
        <h2>{{ title }}</h2>
    </div>
    <ng-container *ngIf="customButtonsTemplate; else btnGroup" [ngTemplateOutlet]="customButtonsTemplate"></ng-container>
</div>


<ng-template #btnGroup>
  <div class="btn-group">
    <button *ngIf="minimizeBtn" (click)="minimize()" tooltip="Minimizar" container="body">
      <i  class="far fa-minus" ></i>
    </button>
    <button *ngIf="closeBtn" (click)="close()" tooltip="Fechar" container="body">
      <i class="far fa-times" ></i>
    </button>
    <ui-btn *ngIf="hBtnConfig" [btn]="hBtnConfig" (btnEvent)="emit($event)"></ui-btn>
    <ui-mini-btn *ngIf="miniBtnConfig" [btn]="miniBtnConfig" (btnEvent)="emitMini($event)"></ui-mini-btn>
  </div>
</ng-template>



